import { render, staticRenderFns } from "./classWorks.vue?vue&type=template&id=411745e3&scoped=true"
import script from "./classWorks.vue?vue&type=script&lang=js"
export * from "./classWorks.vue?vue&type=script&lang=js"
import style0 from "./classWorks.vue?vue&type=style&index=0&id=411745e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411745e3",
  null
  
)

export default component.exports